import React, {useEffect} from "react";
import { Route, Switch } from "react-router-dom";
import routes from "../../../config/routes";
import Page403 from "../../../views/error/Page403";
import Page404 from "../../../views/error/Page404";

function Content() {

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <>
      <Switch>
          {routes.map((route, index) => (
              <Route key={index} {...route} />
          ))}
          <Route path="/403" component={Page403} />
          <Route component={Page404} />
      </Switch>
    </>
  );
}

export default Content;
